import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconGridLayoutStyle0 = cosmosIconCss;

const CosmosIconGridLayout$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconGridLayout extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'e43633f933318fca64a04c322315faa224af8885', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '10dc26283cf7cd319d9850b8b6a8cd67853f61f3', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '159fbbe8128973b394edb2d969bc221f58f6be1a', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M4 4.5a.5.5 0 0 1 .5-.5H7a.5.5 0 0 1 .5.5V7a.5.5 0 0 1-.5.5H4.5A.5.5 0 0 1 4 7V4.5Zm5.25 0a.5.5 0 0 1 .5-.5h2.5a.5.5 0 0 1 .5.5V7a.5.5 0 0 1-.5.5h-2.5a.5.5 0 0 1-.5-.5V4.5ZM15 4a.5.5 0 0 0-.5.5V7a.5.5 0 0 0 .5.5h2.5A.5.5 0 0 0 18 7V4.5a.5.5 0 0 0-.5-.5H15ZM4 9.75a.5.5 0 0 1 .5-.5H7a.5.5 0 0 1 .5.5v2.5a.5.5 0 0 1-.5.5H4.5a.5.5 0 0 1-.5-.5v-2.5Zm5.75-.5a.5.5 0 0 0-.5.5v2.5a.5.5 0 0 0 .5.5h2.5a.5.5 0 0 0 .5-.5v-2.5a.5.5 0 0 0-.5-.5h-2.5Zm4.75.5a.5.5 0 0 1 .5-.5h2.5a.5.5 0 0 1 .5.5v2.5a.5.5 0 0 1-.5.5H15a.5.5 0 0 1-.5-.5v-2.5ZM7 18a.5.5 0 0 0 .5-.5V15a.5.5 0 0 0-.5-.5H4.5a.5.5 0 0 0-.5.5v2.5a.5.5 0 0 0 .5.5H7Zm5.75-.5a.5.5 0 0 1-.5.5h-2.5a.5.5 0 0 1-.5-.5V15a.5.5 0 0 1 .5-.5h2.5a.5.5 0 0 1 .5.5v2.5Zm4.75.5a.5.5 0 0 0 .5-.5V15a.5.5 0 0 0-.5-.5H15a.5.5 0 0 0-.5.5v2.5a.5.5 0 0 0 .5.5h2.5Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconGridLayoutStyle0; }
}, [1, "cosmos-icon-grid-layout", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-grid-layout"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-grid-layout":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconGridLayout$1);
            }
            break;
    } });
}

const CosmosIconGridLayout = CosmosIconGridLayout$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconGridLayout, defineCustomElement };
